export enum ModalStatus {
  None                = 0,
  Confirmation        = 1,
  InProgress          = 2,
  Successful          = 3,
  Failure             = 4
}